<template>
  <div>
    <dialog-handler-error
      :openDialog="isOpenDialog"
      :content="content"
      v-if="isEnableDialog"
    ></dialog-handler-error>
  </div>
</template>

<script>
  import userService from "../../services/userService";
  import userDeptRoleViewService from "../../services/userDeptRoleViewService";
  import authenService from "../../services/authenService";
  import h from "../../services/h";
  import constants from "../../constants";
  import DialogHandlerError from "../../components/DialogHandlerError";
  import errorMessageFilter from "../../filters/errorMessageFilter";

  export default {
  name: "before-enter-app-page",
  components: {DialogHandlerError},

  data() {
    return {
      userDeptRoles: null,
      content: null,
      isOpenDialog: false,
      isEnableDialog: false
    };
  },

  watch: {
    isOpenDialog(newValue) {
      newValue && (this.isEnableDialog = newValue);
    }
  },

  created() {
    this.loadCommonUserInfo()
      .then(() => this.doRouting());
  },

  methods: {
    handleUserDeptRoleNotExists() {
      this.content = errorMessageFilter({
        errorCode: "authenticate.userDeptRoleNotExists"
      });
      this.isOpenDialog = true;
    },

    loadCommonUserInfo() {
      return userService
        .get()
        .then(response => response.data)
        .then(user =>
          userDeptRoleViewService
            .findAllByCurrentUser({deactive: true})
            .then(response => {
              this.userDeptRoles = response.data || [];
              return new Promise((resolve, reject) => {
                if (this.userDeptRoles && this.userDeptRoles.length) {
                  resolve({user: user, userDeptRoles: this.userDeptRoles});
                } else {
                  this.handleUserDeptRoleNotExists();
                  reject(
                    new Error({error: "authenticate.userDeptRoleNotExists"})
                  );
                }
              });
            })
            .then(loginPayload => this.$store.commit("login", loginPayload))
        );
    },

    getStateURLBeforeLogin() {
      let stateURLBeforeLoginJsonStr = authenService.get(
        constants.STATE_URL_BEFORE_LOGIN
      );
      authenService.remove(constants.STATE_URL_BEFORE_LOGIN);
      return stateURLBeforeLoginJsonStr
        ? JSON.parse(stateURLBeforeLoginJsonStr)
        : null;
    },

    defaultRouting() {
      let defaultUserDeptRole =
        h.find(
          this.userDeptRoles,
          item =>
            item.isDefaultRole === constants.TRUE &&
            item.status === constants.USER_DEPT_ROLE.STATUS.ACTIVE
        ) || this.userDeptRoles[0];

      this.$store.commit("changeUserDeptRole", defaultUserDeptRole.id);
      this.$router.replace({
        name: "dashboard",
        params: {userDeptRoleId: defaultUserDeptRole.id}
      });
    },

    doRouting() {
      let stateURLBeforeLogin = this.getStateURLBeforeLogin();
      if (
        stateURLBeforeLogin &&
        (stateURLBeforeLogin.ROUTER_NAME === "detailRouting" ||
          (stateURLBeforeLogin.PARAMS &&
            stateURLBeforeLogin.PARAMS.userDeptRoleId &&
            h.exists(
              this.userDeptRoles,
              item => item.id === stateURLBeforeLogin.PARAMS.userDeptRoleId
            )))
      ) {
        this.$router.replace({
          name: stateURLBeforeLogin.ROUTER_NAME,
          // path: stateURLBeforeLogin.URL,
          query: stateURLBeforeLogin.QUERY,
          params: stateURLBeforeLogin.PARAMS
        });
      } else {
        this.defaultRouting();
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/login/before-enter-app-page.vue